// @flow
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { branch, renderNothing } from "recompose";

import { Translate, useI18n, withI18n } from "@quantum/i18n";
import { FiInfo as IconeHint } from "react-icons/fi";

import {
  Tooltip,
  TooltipArrow,
  TooltipReference,
  useTooltipState,
} from "reakit/Tooltip";

import { compose } from "ramda";

import SelectInput from "../../../comum/SelectInput";
import {
  type ActionCreator,
  selecionarAjusteDias,
  getAjusteDiasAExibir,
  getAjusteDiasSelecionado,
  getPeriodoUnicoSelecionado,
  getIsIndicadorFinanceiroSelecionado,
  getIsPeriodoInicioOuFinalDaSerieSelecionado,
  getPeriodosSelecionados,
} from "../../../../state";
import {
  type Id,
  type AjusteDias,
  ID_PERIODO_DATAS_ESPECIFICAS,
  ID_PERIODO_DATA_ESPECIFICA_INDICADORES_MERCADO,
  ID_PERIODO_ULTIMA_DIVULGACAO,
  ID_PERIODO_ULTIMA_100_PORCENTO_ABERTA,
} from "../../../../model";

import { comEdicaoDeMedida } from "../../Contexto";

type Prop = {
  periodosSelecionados: ?Array<Id>,
  periodoUnicoSelecionado: ?Id,
  listaAjusteDias: Array<AjusteDias>,
  ajusteDiaSelecionado: Id,
  selecionarAjusteDias: ActionCreator,
  isIndicadorFinanceiroSelecionado: boolean,
  isPeriodoInicioOuFinalDeSerieSelecionado: boolean,
};

function SelecaoAjusteDias({
  periodosSelecionados,
  periodoUnicoSelecionado,
  listaAjusteDias,
  ajusteDiaSelecionado,
  selecionarAjusteDias,
  isIndicadorFinanceiroSelecionado,
  isPeriodoInicioOuFinalDeSerieSelecionado,
}: Prop) {
  const { translate } = useI18n();
  const tooltip = useTooltipState();

  useEffect(() => {
    if (periodoUnicoSelecionado === ID_PERIODO_DATAS_ESPECIFICAS) {
      selecionarAjusteDias(0);
    }
  }, [periodoUnicoSelecionado, selecionarAjusteDias]);

  if (
    !listaAjusteDias ||
    !listaAjusteDias.length ||
    isPeriodoInicioOuFinalDeSerieSelecionado ||
    periodoUnicoSelecionado ===
      ID_PERIODO_DATA_ESPECIFICA_INDICADORES_MERCADO ||
    periodoUnicoSelecionado === ID_PERIODO_ULTIMA_DIVULGACAO ||
    periodoUnicoSelecionado === ID_PERIODO_ULTIMA_100_PORCENTO_ABERTA ||
    (periodosSelecionados &&
      periodosSelecionados.length === 2 &&
      periodosSelecionados.includes(ID_PERIODO_ULTIMA_DIVULGACAO) &&
      periodosSelecionados.includes(ID_PERIODO_ULTIMA_100_PORCENTO_ABERTA))
  ) {
    return null;
  }

  function handleAjusteSelecionado(idAjuste) {
    selecionarAjusteDias(idAjuste);
  }

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label ConfiguracaoMedida__label--hint">
        {isIndicadorFinanceiroSelecionado ? (
          <Translate>configuracaoRelatorio.ajuste</Translate>
        ) : (
          <>
            <Translate>Periodo.AjusteDeDias.Descricao</Translate>
            <TooltipReference {...tooltip}>
              <IconeHint />
            </TooltipReference>
            <Tooltip {...tooltip} className="ConfiguracaoMedida__tooltip">
              <Translate>hint.telaPersonalizada.ajusteBanco</Translate>
              <TooltipArrow {...tooltip} />
            </Tooltip>
          </>
        )}
      </label>
      <SelectInput
        className="ConfiguracaoMedida__input-select"
        value={ajusteDiaSelecionado}
        options={listaAjusteDias}
        placeholder={translate("configuracaoRelatorio.placeholderAjuste")}
        onChange={handleAjusteSelecionado}
        multiple={false}
        size={5}
        campoDescricao={"traducao"}
      />
    </div>
  );
}

export default compose(
  withI18n,
  comEdicaoDeMedida,
  branch(({ exibirSelecaoPeriodo }) => !exibirSelecaoPeriodo, renderNothing),
  connect(
    (state, { translate }) => ({
      periodosSelecionados: getPeriodosSelecionados(state),
      periodoUnicoSelecionado: getPeriodoUnicoSelecionado(state),
      listaAjusteDias: getAjusteDiasAExibir(state).map(ajuste => ({
        ...ajuste,
        traducao: translate(ajuste.chaveTraducao),
      })),
      ajusteDiaSelecionado: getAjusteDiasSelecionado(state),
      isIndicadorFinanceiroSelecionado: getIsIndicadorFinanceiroSelecionado(
        state
      ),
      isPeriodoInicioOuFinalDeSerieSelecionado: getIsPeriodoInicioOuFinalDaSerieSelecionado(
        state
      ),
    }),
    { selecionarAjusteDias }
  )
)(SelecaoAjusteDias);
